<template>
    <view-contract-list
        :findText="findText"
        :toolbarShow="false"
        :filterPanelShow="false"
        :selectionMode="'single'"
        :totalCountSelectedShow="false"
        :filterRow="{ visible: false }"
    ></view-contract-list>
</template>
<script>
export default {
    name: 'view-contract-list-search',
};
</script>
<script setup>
import { defineProps } from 'vue';
defineProps({
    findText: { default: '', type: [String] },
});
</script>
